import { useQuery, useInfiniteQuery } from '@tanstack/react-query';
import { PossibleValuesAPI } from '@newo/api/gateway';
import type { IPossibleValuesParams } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const possibleValuesAPI = new PossibleValuesAPI(axios);

// GET possible values
export const usePossibleValuesPaginatedQuery = ({
    url,
    params
}: {
    url: string;
    params: IPossibleValuesParams;
}) => {
    return useInfiniteQuery({
        queryKey: ['possibleValues', url, params],
        queryFn: async ({ pageParam }) =>
            possibleValuesAPI.getPossibleValues(url, {
                ...params,
                page: pageParam
            }),
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            const { page, per, total } = lastPage.metadata;
            if (page * per >= total) {
                return;
            }
            return page + 1;
        },
        enabled: Boolean(url),
        refetchOnWindowFocus: false
    });
};

export const usePossibleValuesQuery = ({
    url,
    params
}: {
    url: string;
    params: IPossibleValuesParams;
}) => {
    return useQuery({
        queryKey: ['possibleValues', url, params],
        queryFn: async () => possibleValuesAPI.getPossibleValues(url, params),
        enabled: Boolean(url)
    });
};
